import script from "./diamondsSearchFormRange.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsSearchFormRange.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsSearchFormRange.vue?vue&type=style&index=0&id=5c39d02b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c39d02b"]])

export default __exports__